import React from "react";
import LoadingSpinner from "../../../../components/ui/loadingSpinner/LoadingSpinner";
import { useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import Layout from "../../layout/Layout";
import JustForYouWrap from "./JustForYouWrap";
import {
  getAllFlashProducts,
  getAllProducts,
} from "../../../../services/products";
import EmptyState from "../../../../components/common/EmptyState";

const JustForYou = (props) => {
  const {
    sendRequest,
    status,
    data: productsData,
    error,
  } = useHttp(getAllFlashProducts, true);

  useEffect(() => {
    sendRequest();
  }, [sendRequest]);

  let content;

  if (status === "completed" && productsData && productsData.length > 0) {
    content = (
      <JustForYouWrap
        customStyle={props.customStyle}
        productItems={productsData}
      />
    );
  }
  if (status === "completed" && (!productsData || productsData.length === 0)) {
    content = <EmptyState
          title="No Products Available"
          message="This particular category route does not contain any matching products right now. Look at our trending selection below!"
          showButton={false}
        />;
  }
  if (error) {
    content = <EmptyState showButton={false} />;
  }
  if (status === "pending") {
    content = (
      <div className="centered">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <Layout sectionId="just-for_u" title="Just For You">
      {content}
    </Layout>
  );
};

export default JustForYou;
